module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Coqb47/tc-custom/9781439675830.jpg?1694070823334",
      "alt": "This image is the cover for the book The Ghostly Tales of Tampa, Spooky America"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Ghostly Tales of Tampa, Spooky America\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ghost stories from Tampa, Florida have never been so creepy, fun, and full of mystery! ")]), _c('br'), _c('p', [_vm._v("The haunted history of Burlington comes to life—even when the main players are dead. Visit the Oaklawn Cemetery for a glimpse of the ghost of Vincent Martinez de Yeor. Or catch a spectral show at the Tampa Theater. Dive into this spooky chapter book for suspenseful tales of bumps in the night, paranormal investigations, and the unexplained; just be sure to keep the light on.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stacia Deutsch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("New York Times Best Selling author Stacia Deutsch has written more than three hundred children's books including The Jessie Files, a spin off of the beloved Boxcar Children mystery series. Stacia lives in Temecula, California, where she is member of the historical society and loves hearing spooky stories! Find her at www.staciadeutsch.com. Instagram @staciadeutsch_writes and www.facebook/staciadeutsch.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0